import { render, staticRenderFns } from "./AnswersIcon.vue?vue&type=template&id=71a4324c&"
import script from "./AnswersIcon.vue?vue&type=script&lang=js&"
export * from "./AnswersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports